// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1irfe","title":"Images45_title__Tanwy","images":"Images45_images__2q_Ch"};